import React, { useState } from "react"
import { Col, Form, Row, Card, Input, Button } from "antd"
import { RouteComponentProps, useHistory } from "react-router-dom"
import CustomSvg from "../svgs/CustomSvg"
import shortid from "shortid"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import ImageUploader from "components-old/forms/ImageUploader"
import { useStore } from "hooks"
import { general } from "store"
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import FormModal from "components-old/forms/FormModal"
import { channelsDef } from "../channels.def"
import { isAldeia } from "hooks/useAldeia"
import { useSetAtom } from "jotai"
import { modalState } from "atoms/app.atom"
import StarAlert from "../StarAlert"

function AddCustom() {
  const [form] = Form.useForm()
  const history = useHistory()
  const { uploadFile } = useStore(general)
  const setModal = useSetAtom(modalState)
  const def = channelsDef.record["custom"]

  return (
    <FormModal
      form={form}
      noPrompt
      defaultValues={{
        identifier: shortid.generate(),
      }}
      onSubmit={async (model: any) => {
        if ((model.avatar as any)?.[0].preview) {
          const formData = new FormData()
          formData.append("avatar", model.avatar![0])
          const uploadResponse: any = await uploadFile({
            data: formData,
          })
          if (!uploadResponse[0].fileName) {
            throw new Error("Error uploading file")
          }
          model.avatar = uploadResponse[0].fileName
        }
        return request.post(endpoints.CUSTOM, model).then(() => {
          toast.success("Canal customizado criado.")
          history.push("/settings/channels")
        })
      }}
      onBack={() => {
        setModal(null)
      }}
      type="drawer"
      width={600}
      stickyFooter={isAldeia}
      titleOverwrite={
        <span className="flex gap-3 items-center text-lg">
          <div className="size-8">{isAldeia ? channelsDef.record["custom"]?.icon : <CustomSvg />}</div>
          Conectar Canal Customizado
        </span>
      }
      // stickyFooter
      hideSuccessMessage
      onSubmitSuccess={() => {
        history.push("/settings/channels")
      }}
      okText="Conectar canal"
    >
      {isAldeia ? (
        <StarAlert type="info" className="mb-4">
          Um canal customizado pode ser controlado usando nossa API para integrar qualquer plataforma de mensagem com a Aldeia.
        </StarAlert>
      ) : (
        <div
          style={{
            fontSize: 16,
            color: "var(--content-secondary)",
            marginLeft: 5,
            marginBottom: 20,
          }}
        >
          Um canal customizado pode ser controlado usando nossa API para integrar qualquer plataforma de mensagem com o Kinbox.
        </div>
      )}
      <Form.Item noStyle name="identifier">
        <div></div>
      </Form.Item>
      <Form.Item>
        <Row justify="center">
          <Col style={{ textAlign: "center" }}>
            <Row justify="center">
              <ImageUploader
                size={100}
                removable
                bottomDescription={
                  <>
                    <div style={{ color: "var(--secondary)" }}>Arraste e solte uma imagem ou faça Upload</div>
                    <div style={{ color: "var(--secondary)", fontSize: 12 }}>JPEG/PNG - Min. 100x100px</div>
                  </>
                }
                avatarPlaceholderIcon={"fal fa-wifi-slash"}
                avatarProps={{
                  placeholderStyle: {
                    backgroundColor: isAldeia ? "var(--selected-lighter)" : "#262525",
                    color: "white",
                  },
                  icon: isAldeia ? def.icon : undefined,
                }}
              />
            </Row>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item
        label="Descrição"
        name="description"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input placeholder="Meu canal" />
      </Form.Item>
      <Form.Item
        shouldUpdate={(prev, values) => {
          return prev.identifier != values.identifier
        }}
        noStyle
      >
        {({ getFieldValue }) => (
          <Form.Item label={`Endpoint para receber mensagens`} help="Envie mensagens para essa URL">
            <Input disabled value={`https://api.kinbox.com.br/api/v1/channels/${getFieldValue("identifier")}/messages`} />
          </Form.Item>
        )}
      </Form.Item>
      <Form.Item
        label={`Endpoint para enviar mensagem e atualização de status`}
        help={`${isAldeia ? "A Aldeia" : "o Kinbox"} vai enviar um POST para essa URL sempre que um membro interagir com uma conversa desse canal`}
        name="hashIdentifier"
      >
        <Input placeholder="https://api.myserver.com/integration/kinbox" />
      </Form.Item>
      <EditEntityCustomFields form={form} entity="channel" />
    </FormModal>
  )
}

export default AddCustom
